import { gql } from "apollo-boost";
import { apolloClient, getApolloOptions } from "./apolloClient";

const GET_XCUBES = gql`
  query ($where: JSON){
    xcubes(sort: "name", where: $where){
      id
      name
      letter
      type
      location {
        id
        name
        time_zone
      }
    }
  }
`;
// 
export const getXCubesSimple = async (filter) => {
    const where = {
        location_null: false,
    };
    if (filter.location) {
        where.location = { id: filter.location };
    }
    if (filter.type) {
        where.type = filter.type;
    }
    if (filter.country) {
        where.location = { country: filter.country };
    }
    if (filter.status && filter.status === "active") {
        where.active = true;
    } else if (filter.status && filter.status === "inactive") {
        where.active = false;
    }

    const res = await apolloClient.query({
        ...getApolloOptions(),
        query: GET_XCUBES,
        variables: { where },
    });

    return res.data.xcubes;
};